import * as types from 'misc/types';
import * as actions from 'misc/actions';

const texts = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.SAGA_TEXTS_GET.REQUEST:
            return actions.load(state);
        case types.SAGA_TEXTS_GET.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_TEXTS_GET.FAILURE:
            return actions.error(state, action.error);
        default:
            return state;
    }
};

export default texts;



// WEBPACK FOOTER //
// ./src/reducers/texts.js